import { createSlice } from '@reduxjs/toolkit'

export interface RefreshState {
  shouldRefreshUserState: boolean
  isUserStateFetched: boolean
  isSpinnerVisible: boolean
  toastMessage: string | null
}

const initialState: RefreshState = {
  shouldRefreshUserState: true,
  isUserStateFetched: false,
  isSpinnerVisible: false,
  toastMessage: null
}

export const refreshSlice = createSlice({
  name: 'refresh',
  initialState,
  reducers: {
    refreshUserState: (state: RefreshState) => {
      state.shouldRefreshUserState = true
      state.isUserStateFetched = false
    },
    setUserStateRefreshed: (state: RefreshState) => {
      state.shouldRefreshUserState = false
    },
    setUserStateFetched: (state: RefreshState) => {
      state.isUserStateFetched = true
    },
    showSpinner: (state: RefreshState) => {
      state.isSpinnerVisible = true
    },
    hideSpinner: (state: RefreshState) => {
      state.isSpinnerVisible = false
    },
    setToastMessage: (state: RefreshState, value: {
      payload: {
        message: string
      }
      type: string
    }) => {
      state.toastMessage = value.payload.message
    },
    resetToastMessage: (state: RefreshState) => {
      state.toastMessage = null
    }
  }
})

export const RefreshActions = refreshSlice.actions

export default refreshSlice.reducer
